const en = {
  orderInformation: 'Order Information',
  orderNumber: 'Order Number',
  createdBy: 'Created By',
  createdAt: 'Created At',
  totalAmount: 'Total Amount',
  totalOrdered: 'Total Ordered',
  delivered: 'Delivered',
  backorder: 'Backorder',
  orderItems: 'Order Items ({{count}})',
  noItems: 'No items in this order',
  colPart: 'Part',
  colOrdered: 'Ordered',
  colDelivered: 'Delivered',
  colBackorder: 'Backorder',
  statusHistory: 'Status History',
  changedBy: '{{date}} by {{who}}',
  system: 'System',
  orderNotes: 'Order Notes',
  status: {
    waitingForAnswer: 'Waiting For Answer',
    toOrder: 'To Order',
    ordered: 'Ordered',
    delivered: 'Delivered',
    partialDelivered: 'Partial Delivered',
    cancelled: 'Cancelled',
    pending: 'Pending',
    partial: 'Partial',
    backorder: 'Backorder',
    completed: 'Completed',
    nla: 'NLA',
    closed: 'Closed',
  },
};

const de = {
  orderInformation: 'Bestellinformationen',
  orderNumber: 'Bestellnummer',
  createdBy: 'Erstellt von',
  createdAt: 'Erstellt am',
  totalAmount: 'Gesamtbetrag',
  totalOrdered: 'Gesamt bestellt',
  delivered: 'Geliefert',
  backorder: 'Rückstand',
  orderItems: 'Bestellpositionen ({{count}})',
  noItems: 'Keine Positionen in dieser Bestellung',
  colPart: 'Teil',
  colOrdered: 'Bestellt',
  colDelivered: 'Geliefert',
  colBackorder: 'Rückstand',
  statusHistory: 'Statusverlauf',
  changedBy: '{{date}} von {{who}}',
  system: 'System',
  orderNotes: 'Bestellnotizen',
  status: {
    waitingForAnswer: 'Warten auf Antwort',
    toOrder: 'Zu bestellen',
    ordered: 'Bestellt',
    delivered: 'Geliefert',
    partialDelivered: 'Teilweise geliefert',
    cancelled: 'Storniert',
    pending: 'Ausstehend',
    partial: 'Teilweise',
    backorder: 'Rückstand',
    completed: 'Abgeschlossen',
    nla: 'NLA',
    closed: 'Geschlossen',
  },
};

const orderDetails = { en, de };
export default orderDetails;
